var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSimpleArrowPrev = function SvgSimpleArrowPrev(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 40,
    viewBox: "0 0 21 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3042 39.7089L0.29294 20.7014C0.107143 20.5144 0.00198746 20.2621 0 19.9985C0.00456047 19.7361 0.109369 19.4853 0.29294 19.2976L19.3042 0.291097C19.555 0.0401663 19.9207 -0.0579279 20.2635 0.0337656C20.6063 0.125459 20.8741 0.39301 20.966 0.735634C21.058 1.07826 20.9601 1.4439 20.7093 1.69483L2.39813 19.9985L20.7093 38.3052C21.0971 38.6931 21.0968 39.3218 20.7088 39.7094C20.3208 40.0971 19.6919 40.0968 19.3042 39.7089Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSimpleArrowPrev, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/simple_arrow_prev.b2fa2e40.svg";
export { ForwardRef as ReactComponent };